import React from 'react';
import { FAQItem } from './types';

export const ULTRA_FAQS: FAQItem[] = [
  {
    id: 'ultra-cost',
    titleKey: 'ultra_faq_cost_title',
    answerContent: (t) => (
      <>
        {t('ultra_faq_cost_existing_owner_body')}
        <br />
        <br />
        {t('ultra_faq_cost_new_owner_body')}
        <br />
        <br />
        {t('ultra_faq_cost_switch_dogs_body')}
      </>
    ),
  },
  {
    id: 'ultra-right-for-me',
    titleKey: 'ultra_faq_right_for_me_title',
    answerKey: 'ultra_faq_right_for_me_body',
  },
  {
    id: 'ultra-where-works',
    titleKey: 'ultra_faq_where_works_title',
    answerKey: 'ultra_faq_where_works_body',
  },
  {
    id: 'ultra-cell-service',
    titleKey: 'ultra_faq_cell_service_title',
    answerKey: 'ultra_faq_cell_service_body',
  },
  {
    id: 'ultra-attach',
    titleKey: 'ultra_faq_attach_title',
    answerKey: 'ultra_faq_attach_body',
  },
  {
    id: 'ultra-battery',
    titleKey: 'ultra_faq_battery_title',
    answerKey: 'ultra_faq_battery_body',
  },
  {
    id: 'ultra-callback-safe',
    titleKey: 'ultra_faq_callback_safe_title',
    answerContent: (t) => (
      <>
        {t('ultra_faq_callback_safe_body')}
        <br />
        <br />
        {t('ultra_faq_callback_best_practices_body')}
      </>
    ),
  },
  {
    id: 'ultra-pair-devices',
    titleKey: 'ultra_faq_pair_devices_title',
    answerKey: 'ultra_faq_pair_devices_body',
  },
];
